import imageCompression from 'browser-image-compression';
import { enqueueSnackbar } from '../snackbar';
import { filesSizeValidator, getFileType } from '../../utils';
import { controlBackdropLoading } from '../../services';
import { INPUT_ERRORS } from '../../const';

const blobToFile = (blob: Blob, fileName: string) => {
  const file = new File([blob], fileName, {
    type: blob.type,
    lastModified: Date.now(),
  });

  return file;
};

const compressFiles = (files: any, withoutCompress?: boolean) =>
  Promise.all(
    Object.values(files).map((file: any) => {
      return new Promise((res) => {
        const isImage = getFileType(file.name) === 'image';
        if (!isImage) return res(file);

        if (withoutCompress && file.size <= 9 * 1024 * 1024) {
          return res(file);
        }

        imageCompression(file, {
          maxSizeMB: withoutCompress ? 9 : 0.3,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
          maxIteration: 10,
          initialQuality: 0.9,
          alwaysKeepResolution: false,
        }).then((compressedFile) => res(blobToFile(compressedFile, file.name)));
      });
    }),
  );

export const readFiles = async (
  e: any,
  onReaded: (readedFiles: any[], files: any[]) => void,
  withoutCompress?: boolean,
) => {
  const files = e.target.files;
  let compressedFiles: any[] = [];
  const readedFiles: any = [];
  controlBackdropLoading(1);

  compressedFiles = await compressFiles(files, withoutCompress);

  for (let i = 0; i < compressedFiles.length; i++) {
    const file = compressedFiles[i];

    const reader = new FileReader();
    reader.onload = () => {
      readedFiles[i] = reader.result;

      if (compressedFiles.length - readedFiles.filter(Boolean).length !== 0) return;

      return onReaded && onReaded(readedFiles, compressedFiles);
    };
    reader.readAsDataURL(file);
  }
  controlBackdropLoading(-1);
};

export const inputFilesValidators = (readedFiles: any[], files: any[]) => {
  if (readedFiles.length > 10) {
    enqueueSnackbar(INPUT_ERRORS.NOT_VALID.MAX_UPLOAD_FILES, 'warning');
    return false;
  }
  if (filesSizeValidator(files)) {
    enqueueSnackbar(filesSizeValidator(files), 'warning');
    return false;
  }

  return true;
};

export const getMultipleValue = (
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
): string[] => {
  let value: string | string[] = e.target.value;
  value = value.split(',');
  const isNewValue = value.length > 1 ? !value[value.length - 1].trim() : false;
  value = value.map((val) => val.trim()).filter((val) => !!val);
  e.target.value = value.join(',') + (isNewValue ? ',' : '');

  return value;
};
